import React from 'react';
import { Spin } from 'antd';
import cn from 'classnames';
import styles from './IsCountingBlock.module.scss';

const IsCountingBlock = ({ className, spinning, children, ...props }) => {
  return (
    <Spin
      {...props}
      wrapperClassName={cn(styles.root, className)}
      spinning={spinning}
    >
      {children}
    </Spin>
  );
};

export default IsCountingBlock;
